<template>
    <v-container>
        <v-row>
            <v-col>
                <subscription-required />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div v-for="level in relevantLevels('TI')" :key="`TI-${level.short}`">
                    <div
                        v-for="resultCategory in resultCategories('TI', level.short)"
                        :key="resultCategory.id"
                        class="mt-4"
                    >
                        <full-results-tabs
                            :meet-id="meetId"
                            :result-category="resultCategory"
                            :results="trampolineResults"
                        />
                    </div>
                </div>

                <div v-for="level in relevantLevels('DM')" :key="`DM-${level.short}`">
                    <div
                        v-for="resultCategory in resultCategories('DM', level.short)"
                        :key="resultCategory.id"
                        class="mt-4"
                    >
                        <full-results-tabs
                            :meet-id="meetId"
                            :result-category="resultCategory"
                            :results="doubleMiniResults"
                        />
                    </div>
                </div>

                <div v-for="level in relevantLevels('TU')" :key="`TU-${level.short}`">
                    <div
                        v-for="resultCategory in resultCategories('TU', level.short)"
                        :key="resultCategory.id"
                        class="mt-4"
                    >
                        <full-results-tabs
                            :meet-id="meetId"
                            :result-category="resultCategory"
                            :results="tumblingResults"
                        />
                    </div>
                </div>

                <div v-for="level in relevantLevels('TS')" :key="`TS-${level.short}`">
                    <div
                        v-for="resultCategory in resultCategories('TS', level.short)"
                        :key="resultCategory.id"
                        class="mt-4"
                    >
                        <full-results-tabs
                            :meet-id="meetId"
                            :result-category="resultCategory"
                            :results="synchroResults"
                        />
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Meet from '@/Models/Meet.js';
import PageMixin from '@/Pages/Page.mixin.js';
import levels from '@/levels.js';
import ResultCategory from '@/Models/ResultCategory.js';
import FullResultsTabs from '@/Components/FullResults/FullResultsTabs.vue';
import SubscriptionRequired from '@/Components/SubscriptionRequired.vue';

export default {
    name: 'FullMeetResults',

    components: { SubscriptionRequired, FullResultsTabs },

    mixins: [PageMixin],

    props: {
        meetId: {
            type: Number,
            required: true,
        },

        pageResultCategories: {
            type: Array,
            required: true,
        },

        results: {
            type: Array,
            required: true,
        },
    },

    computed: {
        meet() {
            return Meet.find(this.meetId);
        },

        trampolineResults() {
            return this.results.filter((result) => result.event === 'TI');
        },

        doubleMiniResults() {
            return this.results.filter((result) => result.event === 'DM');
        },

        tumblingResults() {
            return this.results.filter((result) => result.event === 'TU');
        },

        synchroResults() {
            return this.results.filter((result) => result.event === 'TS');
        },
    },

    methods: {
        eventLevels(event) {
            return ResultCategory.query()
                .where('event', event)
                .orderBy('level')
                .whereIdIn(this.pageResultCategories.map((resultCategory) => resultCategory.id))
                .get();
        },

        relevantLevels(event) {
            const results = _.groupBy(this.eventLevels(event), 'level');

            return levels.filter((level) => {
                if (['YE 11-12', 'YE 13-14'].includes(level.short) && Object.keys(results).includes('YE')) {
                    return true;
                }

                return Object.keys(results).includes(level.short);
            });
        },

        resultCategories(event, level) {
            return ResultCategory.query()
                .where('event', event)
                .where('level', level)
                .orderBy('gender')
                .orderBy('min_age')
                .get();
        },
    },
};
</script>
